/**
 * @generated SignedSource<<0a20f252f9afcbcb49fa400ef891af93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditableFolderItemMenu_folderItemNode$data = {
  readonly __typename: string;
  readonly canPublish: {
    readonly value: boolean;
  };
  readonly content?: {
    readonly __typename: "Form";
    readonly id: string;
  } | {
    readonly __typename: "Page";
    readonly data: UnknownJSON | null;
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id?: string;
  readonly publishState: PublishState;
  readonly " $fragmentSpreads": FragmentRefs<"PublishFolderItemDialog_folderItem">;
  readonly " $fragmentType": "EditableFolderItemMenu_folderItemNode";
};
export type EditableFolderItemMenu_folderItemNode$key = {
  readonly " $data"?: EditableFolderItemMenu_folderItemNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditableFolderItemMenu_folderItemNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditableFolderItemMenu_folderItemNode",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canPublish",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishState",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                }
              ],
              "type": "Page",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/)
              ],
              "type": "Form",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PublishFolderItemDialog_folderItem"
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    }
  ],
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
};
})();

(node as any).hash = "269d314c34177f2aa9681d6d414583b8";

export default node;
